<template>
  <div class="privacy-container">
    <div class="privacy-header">
      <h1 class="privacy-title">aKinder™Volunteer</h1>
      <h2 class="privacy-subtitle">Privacy Policy</h2>
      <p class="privacy-description">
        Type of Applications website: Volunteering website
      </p>
      <p class="privacy-description">
        Effective date: 1st day of January, 2025
      </p>
    </div>

    <div class="privacy-content">
      <div class="privacy-intro">
        <p>
          aKinder™Volunteer (the "Site") is owned and operated by
          aKinder™Company and Legacy Response has a limited license to use
          software within their mission to create community. AKINDer Company can
          be contacted at:
        </p>
        <ul class="contact-list">
          <li><span>Email: dblais@akindercompany.com</span></li>
          <li><span>Phone: (508) 202-3165</span></li>
          <li>
            <span
              >Address: 399 Boylston Street, 6th Floor, Boston, MA 02116</span
            >
          </li>
        </ul>
      </div>

      <div
        v-for="(section, index) in sections"
        :key="index"
        class="privacy-section"
      >
        <h2 class="section-title">{{ section.title }}</h2>
        <div class="section-content" v-html="section.content"></div>

        <div v-if="section.subsections" class="subsections">
          <div
            v-for="(subsection, subIndex) in section.subsections"
            :key="subIndex"
            class="subsection"
          >
            <h3 class="subsection-title">{{ subsection.title }}</h3>
            <div class="subsection-content" v-html="subsection.content"></div>
          </div>
        </div>
      </div>

      <div class="privacy-contact">
        <h2 class="section-title">Contact Information</h2>
        <p>
          If you have any questions, concerns or complaints, you can contact our
          privacy officer, David Blais, at:
        </p>
        <div class="contact-info">
          <p>dblais@akindercompany.com</p>
          <p>(508) 202-3165</p>
          <p>399 Boylston Street, 6th Floor, Boston, MA 02116</p>
        </div>
      </div>

      <div class="privacy-footer">
        <p>
          © {{ new Date().getFullYear() }} aKinder™Company. All rights reserved.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  data() {
    return {
      sections: [
        {
          title: "Purpose",
          content: `The purpose of this privacy policy (this "Privacy Policy") is to inform users of our Site of the following: <br>
            <span class="ml-3">1. The personal data we will collect; <br></span>
            <span class="ml-3">2. Use of collected data; <br></span>
            <span class="ml-3">3. Who has access to the data collected; and <br></span>
            <span class="ml-3">4. The rights of Site users. <br><br></span>
            This Privacy Policy applies in addition to the terms and conditions of our Site.`
        },
        {
          title: "Consent",
          content: `By using our Site users agree that they consent to: <br>
            <span class="ml-3">1. The conditions set out in this Privacy Policy; and <br></span>
            <span class="ml-3">2. The collection, use, and retention of the data listed in this Privacy Policy.<br></span>`
        },
        {
          title: "Personal Data We Collect",
          content: `We only collect data that helps us achieve the purpose set out in this Privacy Policy. We will not collect any additional data beyond the data listed below without notifying you first.`,
          subsections: [
            {
              title: "Data Collected Automatically",
              content: `When you visit and use our Site, we may automatically collect and store the following information:
                <div class="list-item">1. Location</div>
                <div class="list-item">2. Email</div>
                <div class="list-item">3. Phone number</div>`
            }
          ]
        },
        {
          title: "How We Use Personal Data",
          content: `Data collected on our Site will only be used for the purposes specified in this Privacy Policy or indicated on the relevant pages of our Site. We will not use your data beyond what we disclose in this Privacy Policy.
            <br><br>The data we collect automatically is used for the following purposes:
            <div class="list-item">1. Statistics</div>
            <div class="list-item">2. Analysis</div>
            <div class="list-item">3. Account Management</div>`
        },
        {
          title: "Who We Share Personal Data With",
          subsections: [
            {
              title: "Employees",
              content:
                "We may disclose user data to any member of our organization who reasonably needs access to user data to achieve the purposes set out in this Privacy Policy."
            },
            {
              title: "Other Disclosures",
              content: `We will not sell or share your data with other third parties, except in the following cases:
                <div class="list-item">1. If the law requires it;</div>
                <div class="list-item">2. If it is required for any legal proceeding;</div>
                <div class="list-item">3. To prove or protect our legal rights; and</div>
                <div class="list-item">4. To buyers or potential buyers of this company in the event that we seek to sell the company.</div>`
            }
          ]
        },
        {
          title: "Data Collected from Third-Party Integrations",
          content:
            "When you choose to link your social media profiles (Facebook, Instagram, LinkedIn, Twitter, TikTok) to our platform, we only collect an access token. This token allows us to publish events to your linked social media profiles upon your consent. We do not collect or have access to any other personal data from your linked social media accounts."
        },
        {
          title: "Use of Third-Party Integration Data",
          content:
            "The access tokens collected from third-party integrations are used exclusively to publish events to your linked social media profiles upon your action and consent. They are not used for any other purpose."
        },
        {
          title: "Third-Party Social Media Platforms",
          content:
            "When you choose to publish events on linked social media platforms via our Site, the content, including media and text, is shared to those platforms. However, we do not share any personal data or access tokens with these platforms beyond what's necessary to publish the content."
        },
        {
          title: "How Long We Store Personal Data",
          content:
            "User data will be stored until the purpose the data was collected for has been achieved.<br><br>You will be notified if your data is kept for longer than this period."
        },
        {
          title: "How We Protect Your Personal Data",
          content:
            "In order to protect your security, we use the strongest available browser encryption and store all of our data on servers in secure facilities. All data is only accessible to our employees. Our employees are bound by strict confidentiality agreements and a breach of this agreement would result in the employee's termination.<br><br>While we take all reasonable precautions to ensure that user data is secure and that users are protected, there always remains the risk of harm. The Internet as a whole can be insecure at times and therefore we are unable to guarantee the security of user data beyond what is reasonably practical."
        },
        {
          title: "Children",
          content:
            "We do not knowingly collect or use personal data from children under 13 years of age. If we learn that we have collected personal data from a child under 13 years of age, the personal data will be deleted as soon as possible. If a child under 13 years of age has provided us with personal data their parent or guardian may contact our privacy officer."
        },
        {
          title:
            "How to Access, Modify, Delete, or Challenge the Data Collected",
          content: `If you would like to know if we have collected your personal data, how we have used your personal data, if we have disclosed your personal data and to who we disclosed your personal data, or if you would like your data to be deleted or modified in any way, please contact our privacy officer here:<br><br>
            <div class="officer-info">
              David Blais<br>
              dblais@danielstable.org<br>
              (781) 964-0000<br>
              399 Boylston Street, 6th Floor, Boston, MA 02116<br>
            </div>`
        },
        {
          title: "How to Opt-Out of Data Collection, Use or Disclosure",
          content: `In addition to the method(s) described in the How to Access, Modify, Delete, or Challenge the Data Collected section, we provide the following specific opt-out methods for the forms of collection, use, or disclosure of your personal data specified below:<br><br>
            <div class="list-item">You can opt-out of the use of your personal data for marketing emails. You can opt-out by clicking "unsubscribe" on the bottom of any marketing email or updating your email preferences under "Your Account"</div>`
        },
        {
          title: "Modifications",
          content:
            'This Privacy Policy may be amended from time to time in order to maintain compliance with the law and to reflect any changes to our data collection process. When we amend this Privacy Policy we will update the "Effective Date" at the top of this Privacy Policy. We recommend that our users periodically review our Privacy Policy to ensure that they are notified of any updates. If necessary, we may notify users by email of changes to this Privacy Policy.'
        }
      ]
    };
  }
};
</script>

<style scoped>
:root {
  --primary-color: #4a90e2;
  --secondary-color: #5cb85c;
  --accent-color: #f8f9fa;
  --text-color: #333;
  --border-color: #e0e0e0;
}

.privacy-container {
  max-width: 1000px;
  margin: 0 auto;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: var(--text-color);
  padding: 20px;
}

.privacy-header {
  text-align: center;
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background: linear-gradient(135deg, #4a90e2, #5cb85c);
  color: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.privacy-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.privacy-subtitle {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.privacy-description {
  font-size: 1.1rem;
  opacity: 0.9;
  margin: 0.25rem 0;
}

.privacy-content {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 2rem;
}

.privacy-intro {
  margin-bottom: 2rem;
  font-size: 1rem;
}

.contact-list {
  list-style-type: none;
  padding: 1rem;
  margin: 1rem 0;
  background-color: #f8f9fa;
  border-radius: 6px;
}

.contact-list li {
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
}

.contact-list li::before {
  content: "•";
  color: var(--primary-color);
  font-weight: bold;
  margin-right: 0.75rem;
}

.privacy-section {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--border-color);
}

.section-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #2c3e50;
}

.section-content {
  font-size: 1rem;
  margin-bottom: 0.5rem;
}

.subsections {
  margin-top: 1rem;
}

.subsection {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.subsection-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: #2c3e50;
}

.subsection-content {
  font-size: 1rem;
  padding-left: 0.5rem;
}

.list-item {
  padding-left: 1.5rem;
  margin-top: 0.5rem;
  position: relative;
}

.list-item::before {
  content: "•";
  color: var(--primary-color);
  position: absolute;
  left: 0.5rem;
}

.ml-3 {
  padding-left: 1.5rem;
  display: block;
  margin-top: 0.3rem;
}

.officer-info {
  background-color: #f0f7ff;
  padding: 1rem;
  border-radius: 6px;
  margin-top: 0.5rem;
  line-height: 1.8;
}

.privacy-contact {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.contact-info {
  padding: 1.5rem;
  background-color: #f0f7ff;
  border-radius: 6px;
  margin-top: 1rem;
  line-height: 1.8;
}

.privacy-footer {
  text-align: center;
  margin-top: 3rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--border-color);
  font-size: 0.9rem;
  color: #6c757d;
}

@media (max-width: 768px) {
  .privacy-container {
    padding: 10px;
  }

  .privacy-header {
    padding: 1.5rem 1rem;
  }

  .privacy-title {
    font-size: 1.5rem;
  }

  .privacy-subtitle {
    font-size: 1.3rem;
  }

  .privacy-content {
    padding: 1.5rem;
  }

  .section-title {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .privacy-header {
    padding: 1.2rem 0.8rem;
  }

  .privacy-title {
    font-size: 1.3rem;
  }

  .privacy-subtitle {
    font-size: 1.1rem;
  }

  .privacy-content {
    padding: 1rem;
  }

  .section-title {
    font-size: 1rem;
  }

  .subsection-title {
    font-size: 0.95rem;
  }
}
</style>
